<template>
  <div class="nav-bar-layout">
    <div class="top-bar">
      <img src="../../../assets/images/logo.png" class="logo-img">
      <el-dropdown>
        <div class="user-info">
          <img src="../../../assets/images/user_avatar.png" class="user-img">
          <span class="user-name">{{ name }}</span>
          <i class="el-icon-arrow-down el-icon--right" style="color: #fff;font-size: 12px;"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span @click="handleLogout">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="bottom-bar">
      <div class="nav-bar">
        <div :class="{ 'nav-item': true, 'active-item': v.type === currentNav }" v-for="v, i in trainNavList" :key="i"
          @click="handleSelect(v.type)">{{ v.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { trainNavList } from '@src/constant/nav'

const moduleUser = namespace('user')

@Component
export default class Home extends Vue {
  @Prop(String)
  currentNav

  @Emit('select')
  handleSelect() { }

  @moduleUser.Getter
  name

  @moduleUser.Action
  Logout

  trainNavList = trainNavList

  async handleLogout() {
    await this.Logout()
    location.reload()
  }
}
</script>

<style lang="scss" scoped>
.nav-bar-layout {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  aspect-ratio: 8;
  padding: 30px 50px 20px;
  border-radius: 0 0 50px 50px;
  background-size: 100% 100%;
  background-image: url('../../../assets/images/nav_bar_background.png');

  .top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo-img {
      width: 150px;
    }

    .user-info {
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 5px 10px;
      border: 1px solid #fff;
      border-radius: 20px;
      cursor: pointer;

      .user-img {
        width: 30px;
        height: 30px;
      }

      .user-name {
        color: #fff;
      }
    }
  }

  .bottom-bar {
    display: flex;
    justify-content: center;

    .nav-bar {
      display: flex;
      gap: 40px;
      background-color: rgba(69, 74, 171, 0.80);
      border: 2px solid rgba(255, 255, 255, 0.43);
      border-radius: 38px;
      padding: 8px;
      overflow: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      .nav-item {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        height: 40px;
        padding: 0 18px;
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        background: transparent;
        border-radius: 38px;
        border: 2px solid transparent;
        cursor: pointer;
      }

      .active-item {
        background: linear-gradient(180deg, #FFAB40 0%, #F17400 100%);
        border: 2px solid rgba(255, 255, 255, 0.3);
      }
    }
  }
}
</style>
